import { useEffect } from 'react';
import { version } from './version';
export function useAlgoliaAgent(props) {
  useEffect(() => {
    props.recommendClient.addAlgoliaAgent('recommend-react', version);
  }, [props.recommendClient]);
}